import { API_PREFIX, Request } from "./request"

export interface listParams {
  current?: any
  params?: any
  settleState?: any
  size?: any
  timeHead?: any
  timeTail?: any
}

//获取处方管理列表
export function getPrescriptionManagement(params: listParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/chainRecipe/page`,
    method: "GET",
    params,
  }
}

export interface checkParams {
  recipeId?: any
  paymentId?: any
}

export function getChainReview(params: checkParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/chainRecipe/chainReview`,
    method: "GET",
    params,
  }
}


export function getApplyRefund(params: checkParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/chainRecipe/applyRefund`,
    method: "GET",
    params,
  }
}

export function getMarkDecoct(params: checkParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/chainRecipe/markDecoct`,
    method: "GET",
    params,
  }
}


export function getPrescriptionManagementDetail(params: checkParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/chainRecipeItem/detail`,
    method: "GET",
    params,
  }
}
